export default {"src":"/_next/static/media/airplane_24.d36ea538.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};